import Vue from 'vue'
import { ToastOptions } from 'vue-toasted'

const defaultOptions: ToastOptions = {
  position: 'top-center',
  duration: 3000,
}

export const success: ToastOptions = {
  ...defaultOptions,
  type: 'success',
}

export const info: ToastOptions = {
  ...defaultOptions,
  type: 'info',
}

export function showToast(msg: string, options: ToastOptions = success) {
  Vue.toasted.show(msg, options)
}

export function showInfo(msg: string) {
  showToast(msg, info)
}
